import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumEqual',
  standalone: false,
})
export class EnumEqualPipe implements PipeTransform {
  transform(field, value, type) {
    return field === value || field === value.toString() || field === type[value];
  }
}
